<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onDelete(close)">
			<div class="modal-header bg-danger text-white py-2">
				<h1 class="modal-title fs-5">{{$t('header.discipline-delete')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="alert alert-info">{{name}} ({{lang}})</div>
				<div>{{$t('text.confirm-discipline-delete')}}</div>
				<div class="m-t"><span style="color: #900;">{{$t('text.attention')}}</span> {{$t('text.warning.discipline-delete')}}</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-danger" :disabled="loading">{{$t('btn.delete')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		name: '',
		lang: '',
		
		error: '',
		loading: false,
	}),
	methods: {
		async onDelete(close){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doDeleteDiscipline(this.$vfm.modals[0].params._value.discipline.id);
			if(ret.success){
				this.$emit('delete', close);
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
	},
	mounted(){
		this.name = this.$vfm.modals[0].params._value.discipline.name;
		this.lang = this.$vfm.modals[0].params._value.discipline.lang;
	},
}
</script>